import React from "react";

export const DeviceTypeIconServer = (): JSX.Element => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" fill="none" />
            <path
                d="M35.1875 13.0576C35.4361 13.0576 35.6746 12.9588 35.8504 12.783C36.0262 12.6072 36.125 12.3688 36.125 12.1201V3.37012C36.125 3.12148 36.0262 2.88302 35.8504 2.7072C35.6746 2.53139 35.4361 2.43262 35.1875 2.43262H3.9375C3.68886 2.43262 3.4504 2.53139 3.27459 2.7072C3.09877 2.88302 3 3.12148 3 3.37012V12.1201C3 12.3688 3.09877 12.6072 3.27459 12.783C3.4504 12.9588 3.68886 13.0576 3.9375 13.0576H18.625V14.6876H3.9375C3.68886 14.6876 3.4504 14.7863 3.27459 14.9621C3.09877 15.138 3 15.3764 3 15.6251V24.3751C3 24.6237 3.09877 24.8622 3.27459 25.038C3.4504 25.2138 3.68886 25.3126 3.9375 25.3126H18.625V26.9425H3.9375C3.68886 26.9425 3.4504 27.0413 3.27459 27.2171C3.09877 27.3929 3 27.6313 3 27.88V36.63C3 36.8786 3.09877 37.1171 3.27459 37.2929C3.4504 37.4687 3.68886 37.5675 3.9375 37.5675H35.1875C35.4361 37.5675 35.6746 37.4687 35.8504 37.2929C36.0262 37.1171 36.125 36.8786 36.125 36.63V27.88C36.125 27.6313 36.0262 27.3929 35.8504 27.2171C35.6746 27.0413 35.4361 26.9425 35.1875 26.9425H20.5V25.3126H35.1875C35.4361 25.3126 35.6746 25.2138 35.8504 25.038C36.0262 24.8622 36.125 24.6237 36.125 24.3751V15.6251C36.125 15.3764 36.0262 15.138 35.8504 14.9621C35.6746 14.7863 35.4361 14.6876 35.1875 14.6876H20.5V13.0576H35.1875ZM34.25 35.6925H4.875V28.8175H34.25V35.6925ZM34.25 23.4376H4.875V16.5626H34.25V23.4376ZM4.875 4.30762H34.25V11.1826H4.875V4.30762Z"
                fill="url(#paint0_linear_799_6833)"
            />
            <path
                d="M29.6729 9.62012C30.7084 9.62012 31.5479 8.78065 31.5479 7.74512C31.5479 6.70958 30.7084 5.87012 29.6729 5.87012C28.6373 5.87012 27.7979 6.70958 27.7979 7.74512C27.7979 8.78065 28.6373 9.62012 29.6729 9.62012Z"
                fill="url(#paint1_linear_799_6833)"
            />
            <path
                d="M29.6729 22.1047C30.7084 22.1047 31.5479 21.2653 31.5479 20.2297C31.5479 19.1942 30.7084 18.3547 29.6729 18.3547C28.6373 18.3547 27.7979 19.1942 27.7979 20.2297C27.7979 21.2653 28.6373 22.1047 29.6729 22.1047Z"
                fill="url(#paint2_linear_799_6833)"
            />
            <path
                d="M29.6729 34.3596C30.7084 34.3596 31.5479 33.5202 31.5479 32.4846C31.5479 31.4491 30.7084 30.6096 29.6729 30.6096C28.6373 30.6096 27.7979 31.4491 27.7979 32.4846C27.7979 33.5202 28.6373 34.3596 29.6729 34.3596Z"
                fill="url(#paint3_linear_799_6833)"
            />
            <path
                d="M12.8401 8.4375H8.3125C8.06386 8.4375 7.8254 8.33873 7.64959 8.16291C7.47377 7.9871 7.375 7.74864 7.375 7.5C7.375 7.25136 7.47377 7.0129 7.64959 6.83709C7.8254 6.66127 8.06386 6.5625 8.3125 6.5625H12.8401C13.0887 6.5625 13.3272 6.66127 13.503 6.83709C13.6788 7.0129 13.7776 7.25136 13.7776 7.5C13.7776 7.74864 13.6788 7.9871 13.503 8.16291C13.3272 8.33873 13.0887 8.4375 12.8401 8.4375Z"
                fill="url(#paint4_linear_799_6833)"
            />
            <path
                d="M12.8401 20.9375H8.3125C8.06386 20.9375 7.8254 20.8387 7.64959 20.6629C7.47377 20.4871 7.375 20.2486 7.375 20C7.375 19.7514 7.47377 19.5129 7.64959 19.3371C7.8254 19.1613 8.06386 19.0625 8.3125 19.0625H12.8401C13.0887 19.0625 13.3272 19.1613 13.503 19.3371C13.6788 19.5129 13.7776 19.7514 13.7776 20C13.7776 20.2486 13.6788 20.4871 13.503 20.6629C13.3272 20.8387 13.0887 20.9375 12.8401 20.9375Z"
                fill="url(#paint5_linear_799_6833)"
            />
            <path
                d="M12.8401 33.4375H8.3125C8.06386 33.4375 7.8254 33.3387 7.64959 33.1629C7.47377 32.9871 7.375 32.7486 7.375 32.5C7.375 32.2514 7.47377 32.0129 7.64959 31.8371C7.8254 31.6613 8.06386 31.5625 8.3125 31.5625H12.8401C13.0887 31.5625 13.3272 31.6613 13.503 31.8371C13.6788 32.0129 13.7776 32.2514 13.7776 32.5C13.7776 32.7486 13.6788 32.9871 13.503 33.1629C13.3272 33.3387 13.0887 33.4375 12.8401 33.4375Z"
                fill="url(#paint6_linear_799_6833)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_799_6833"
                    x1="36.3529"
                    y1="3.20968"
                    x2="2.77213"
                    y2="36.7904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.2347" stopColor="#3959A2" />
                    <stop offset="0.6172" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_799_6833"
                    x1="36.3529"
                    y1="3.20962"
                    x2="2.77216"
                    y2="36.7904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.2347" stopColor="#3959A2" />
                    <stop offset="0.6172" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_799_6833"
                    x1="36.3529"
                    y1="3.20961"
                    x2="2.77216"
                    y2="36.7904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.2347" stopColor="#3959A2" />
                    <stop offset="0.6172" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_799_6833"
                    x1="36.3529"
                    y1="3.20956"
                    x2="2.77216"
                    y2="36.7903"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.2347" stopColor="#3959A2" />
                    <stop offset="0.6172" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_799_6833"
                    x1="36.3529"
                    y1="3.20962"
                    x2="2.77213"
                    y2="36.7904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.2347" stopColor="#3959A2" />
                    <stop offset="0.6172" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_799_6833"
                    x1="36.3529"
                    y1="3.20962"
                    x2="2.77213"
                    y2="36.7904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.2347" stopColor="#3959A2" />
                    <stop offset="0.6172" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_799_6833"
                    x1="36.3529"
                    y1="3.20962"
                    x2="2.77213"
                    y2="36.7904"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C5EAB" />
                    <stop offset="0.2347" stopColor="#3959A2" />
                    <stop offset="0.6172" stopColor="#304B8A" />
                    <stop offset="1" stopColor="#253A6B" />
                </linearGradient>
            </defs>
        </svg>
    );
};
